import loading from './loading.vue'

const Loading = {
  install: function (Vue) {
    Vue.component('Loading', loading)
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/loading.js